export enum FeatureFlag {
  // If you're going to register any new feature flags, ensure you register them on the backend too, and with the same value. They live in FeatureFlagKeys.cs.

  /// <summary>
  /// The feature flag config interface on the frontend, accessed through profile menu. Frontend exclusive
  /// </summary>
  FeatureFlagModal = 1,

  /// <summary>
  /// Allows access to convenient tools which make development and testing a bit easier. This can include extra debug
  /// info in outputs, tools to easily import and export raw json, or whatever is useful at the time. These dev tools
  /// will not be generally available in production environments but can be enabled ad hoc when needed to help with
  /// something.
  /// </summary>
  EraDevTools = 2,

  /// <summary>
  /// This is something that development started on and got abandoned as it didn't really fit with 4.0. It may or may
  /// not get completed in future.
  /// </summary>
  DealThesisHistoricInputs = 1000,

  /// <summary>
  /// Tells the frontend to ignore the "maintenance mode active" behaviour.
  /// </summary>
  BypassMaintenanceMode = 1001,

  /// <summary>
  /// Shows a monitor UI for signalr connections. Frontend exclusive.
  /// </summary>
  SignalrMonitor = 1002,

  /// <summary>
  /// A frontend button to download all the outputs from the current project as a zip file. Frontend exclusive.
  /// </summary>
  AiPackage = 1004,
}

/// <summary>
/// Where the resolved value of a feature flag came from.
/// </summary>
export enum FeatureFlagSource {
  Unset = 0,
  Client = 1,
  Server = 2,
}
